import TempAccountMessageRegulationHelper from "../../../helpers/temp_account_message_helper";
import NewJerseyResponsibleGamingIconsController from "../../../../../components/regulation_components/us/new_jersey/responsible_gaming_icons/new_jersey_responsible_gaming_icons_controller";
import {CGP_ERROR_CODES} from "../../../../../exceptions/cgp_error_codes";
import {REGULATION_CODE_TYPES} from '../../../regulation_const';
import USBaseRegulation from '../us_base_regulation';


export default class NewJerseyRegulation extends USBaseRegulation {

    static CLASS = 'NewJerseyRegulation';

    protected _getRegulationType(): number {
        return REGULATION_CODE_TYPES.NJ;
    }

    showTempAccountMessage(closeFunc) {
        TempAccountMessageRegulationHelper.create({
            serviceFactory: this.serviceFactory
        }).showTempAccountMessage({
            closeFunc: closeFunc,
            messageKey: 'nj_temp_account_message',
            titleKey: 'temp_account_title',
            btnNameKey: 'temp_account_upload_btn'
        });
    }

    forceHideCloseButtonInMembership() {
        return true;
    }

    showLogoutMessage() {
        this.serviceFactory.messageManagerService().openMessage({
            text: this.serviceFactory.languageService().translation('logout_message_text'),
            title: this.serviceFactory.languageService().translation('logout_message_title'),
            customCSSClassList: ['cgp-mdp-text-support-slash-n'],
            hasDefaultButton: false,
            buttons: [
                {
                    name: this.serviceFactory.languageService().translation('mdp_ok'),
                    isClosable: true
                }
            ]
        });
    }

    getResponsibleGamingIconsComponent(params) {
        return NewJerseyResponsibleGamingIconsController.create(params);
    }

    getErrorMessage(errorCode) {
        errorCode = errorCode.toString();
        if(errorCode === CGP_ERROR_CODES.TIME_LIMIT_REACHED_DAILY.toString()) {
            return this.serviceFactory.languageService().translation(CGP_ERROR_CODES.TIME_LIMIT_REACHED_DAILY + '_nj');
        }

        return super.getErrorMessage(errorCode);
    }
}
